import {
	array,
	boolean,
	intersect,
	literal,
	number,
	partial,
	record,
	string,
	struct,
} from 'io-ts/Decoder';

import { Path as GeometryPath } from '../../../ui/geometry';

export const Path = intersect(
	struct({
		id: string,
		name: string,
		type: literal('path'),
		color: string,
		paths: array(GeometryPath),
	})
)(
	partial({
		cutouts: array(GeometryPath),
		measurementValues: record(number),
		isImported: boolean,
	})
);
